"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplifiedSignalIdSchema = exports.SignalIdSchema = void 0;
const zod_1 = require("zod");
exports.SignalIdSchema = zod_1.default.union([zod_1.default.string(), zod_1.default.number()]);
exports.SimplifiedSignalIdSchema = zod_1.default.coerce.string();
//# sourceMappingURL=SignalId.js.map